import { render } from "./PriceDelete.vue?vue&type=template&id=2d2af117&ts=true"
import script from "./PriceDelete.vue?vue&type=script&lang=ts"
export * from "./PriceDelete.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__